import { render, staticRenderFns } from "./DataTableLayout.vue?vue&type=template&id=121ac43d&scoped=true&"
import script from "./DataTableLayout.vue?vue&type=script&lang=js&"
export * from "./DataTableLayout.vue?vue&type=script&lang=js&"
import style0 from "./DataTableLayout.vue?vue&type=style&index=0&id=121ac43d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121ac43d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDataTable,VRow})
